import React, { Component } from 'react'
import ReadSign from 'components/chatBot/messageTypes/messageComponents/readSign';


export default class UploadImage extends Component {

  constructor(props) {
    super(props);

    this.className = "message message-text fade-in outgoing last-message picture";
    this.state={
        avatarMoved: false
    };
  }

  componentDidUpdate() {
      if(this.props.image && this.props.image.uploadStatus === 'uploading' && !this.state.avatarMoved){
          this.props.moveAvatar(this.className);
          this.setState({avatarMoved: true});
      }
  }

    render() {
    let image, statusClass, blurClass = '';
    if (this.props.image){
      image = URL.createObjectURL(this.props.image.file);
      statusClass = this.props.image.uploadStatus === 'uploading' ? 'zap-loader' : this.props.image.uploadStatus === 'error' ? 'exclamation-red' : '';
      blurClass = this.props.image.uploadStatus === 'success' ? '' : 'blur-img ';
    }
    return (
      <div  id="uploading-img" className={this.className}>
        <img className={`upload-img-ctn ${blurClass}`} src={image}/>
        <div className={statusClass}></div>
        <div className="message-time"> { `Today ${this.props.message.time}`} </div>
        <ReadSign />
      </div>
    );
  }
}